export function redirect(state){
    return state.redirect
}

export function token(state){
    return state.token
}